import { supabase } from '@/lib/supabase';
import { readDashboardPages } from '../dashboardData.js';
export async function loadWarehouseDashboard(signal, onBlock) {
  const product='product:products(code, description, temporada, price)';
  const jobs={
    inventory:()=>readDashboardPages(()=>supabase.from('inventory').select(`id,product_id,size,color,quantity,pending_orders,${product}`,{count:'exact'}).order('id'),signal),
    orders:()=>readDashboardPages(()=>supabase.from('order_items').select(`id,product_id,size,color,quantity,pending_quantity,delivered_quantity,preparation_quantity,price,${product},order:orders!inner(id,number,date,fecha_entrega,status,customer_id,customer:customers(name))`,{count:'exact'}).order('id'),signal),
  };
  await Promise.all(Object.entries(jobs).map(async([key,job])=>{
    try{const data=await job();if(!signal.aborted)onBlock(key,{data});}
    catch(error){if(!signal.aborted)onBlock(key,{error:error.message || 'No se pudo consultar la fuente'});}
  }));
}
